




















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import { UserModule } from '@/store/modules/user.module'
import { ChainModule } from '@/store/modules/chain.module'
import GoBack from '@/components/GoBack.vue'
import AllTasks from '../../components/AllTasks.vue'
import api from '@/api'
import UserDetails from './components/UserDetails.vue'
import { EUserStatus, IChain } from '@zunta/configurations'
import { FacilityModule } from '@/store/modules/facility.module'
import TaskDetails from '../../components/TaskDetails.vue'
import BaseComments from '../../components/BaseComments.vue'
import TrainingDetails from './components/TrainingDetails.vue'
import AlertsDetails from './components/AlertsDetails.vue'
import ButtonWithDropdown from '@/components/ButtonWithDropdown.vue'
import Icon from '@/components/Icon.vue'
import { NoCache } from '@/decorators/NoCache'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { PermissionsModule } from '@/store/modules/permissions.module'

@Component({
  components: {
    ButtonWithDropdown,
    Icon,
    Card,
    GoBack,
    AllTasks,
    UserDetails,
    TaskDetails,
    BaseComments,
    TrainingDetails,
    AlertsDetails,
    LoaderWrapper
  }
})
export default class UserPage extends Vue {
  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store);
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store);

  isLoading = true
  showAllTasks: boolean = false

  @NoCache
  get todosPagination () {
    return this.$store.state.user.todosPagination
  }

  @NoCache
  get usersPagination () {
    return this.$store.state.user.usersPagination
  }

  get user () {
    return this.$store.state.user.selectedUser
  }

  get chain () {
    return this.user.chain
  }

  get onboardingData () {
    return this.$store.state.chain.onboardingData
  }

  get userId () {
    return this.$route.params.id
  }

  get todoId () {
    return this.$route.params.todo
  }

  get assignedTo () {
    return this.$route.query.assignedTo
  }

  get rolesList () {
    return this.$store.state.permissions.roles
  }

  get dropdownOptions () {
    return (this.rolesList || []).map((role: any) => {
      return {
          key: role.id,
          value: role.id,
          content: role.name
        }
    })
  }

  async mounted () {
    await this.fetchData()
    this.facilityModuleInstance.getFacilityList({
      facilities: this.user.facilities,
      chain: this.user.chain.id
    })
    this.$watch('todoId', async (value1: any, value2: any) => {
      if (+value1 !== +value2) {
        await this.fetchData()
        this.$forceUpdate()
      }
    })
    this.$watch('userId', async (value1: any, value2: any) => {
      if (+value1 !== +value2) {
        if (!this.todoId) {
          await this.fetchData()
          this.$forceUpdate()
        }
      }
    })
  }

  async fetchComments () {
    await this.userModuleInstance.fetchChaiUserComments(this.user.id)
  }

  async fetchData () {
    this.isLoading = true
    await Promise.all([
      this.chainModuleInstance.fetchUserAdminTasks(this.userId),
      this.userModuleInstance.getAdminUsersList({
        status: EUserStatus.ACTIVE
      }),
      this.chainModuleInstance.fetchTrainingTemplates(),
      this.userModuleInstance.fetchUserTrainingMilestones(this.userId),
      this.userModuleInstance.fetchUserAlertSettings(this.userId),
      this.userModuleInstance.fetchAlerts(this.userId),
      this.userModuleInstance.fetchUserById(this.userId)
    ])
    await this.permissionsModuleInstance.getUserRoles(this.user.chain && this.user.chain.id ? this.user.chain.id : this.user.chain)

    if (this.todoId) {
      await this.userModuleInstance.fetchTodosPagination({ todo: this.todoId, query: this.$route.query })
    } else {
      await this.userModuleInstance.fetchUsersPagination({ current: this.userId, ...this.$route.query })
    }

    this.isLoading = false
  }

  async updateComments () {

  }

  async loginAsAdmin (roleId?: number) {
    const token = await api.auth.getChainManagerToken({
      chainId: (this.user.chain as IChain).id,
      roleId: roleId || undefined
    })
    const route = this.$router.resolve({
      name: 'management-todo',
      query: {
        token
      }
    })

    this.$locationManager.openNewTab(route.href, true)
  }

  async loginAsUser () {
    const token = await api.auth.getUserToken(this.user.id)
    const route = this.$router.resolve({
      name: 'management-todo',
      query: {
        token
      }
    })
    this.$locationManager.openNewTab(route.href, true)
  }

  async goPrevTodo () {
    const todo = this.todosPagination.prev
    this.gotoTodo(todo)
  }

  goNextTodo () {
    const todo = this.todosPagination.next
    this.gotoTodo(todo)
  }

  goPrevUser () {
    const user = this.usersPagination.prev
    this.gotoUser(user)
  }

  goNextUser () {
    const user = this.usersPagination.next
    this.gotoUser(user)
  }

  gotoUser (user: any) {
    this.$router.push({ name: 'admin-facilities-users-page', params: { id: user.id }, query: this.$route.query })
  }

  gotoTodo (todo: any) {
    if (todo.alert) {
      this.$router.push({ name: 'admin-facilities-users-page-todo', params: { id: todo.user.id, todo: todo.id }, query: this.$route.query })
    } else {
      if (todo.user) {
        this.$router.push({ name: 'admin-facilities-users-page-todo', params: { id: todo.user.id, todo: todo.id }, query: this.$route.query })
      } else {
        this.$router.push({ name: 'admin-chain-page-todo', params: { id: todo.chain.id, todo: todo.id }, query: this.$route.query })
      }
    }
  }
}
